import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { Url } from "../../../../../router/enums";
import { makes } from "../../../../../shared";
import {
  selectIsSelectedVehicleCar,
  selectIsSelectedVehicleOther,
  selectVehicleOwnerAvailableModels,
  selectVehicleOwnerVehicleData,
} from "../vehicleOwner.selectors";
import {
  setAvailableModels,
  setUIField,
  setVehicleType,
} from "../vehicleOwner.slice";

import { ComponentId } from "./enums";

export const main: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.VEHICLE_OWNER_VEHICLE,
  id: [FormId.VEHICLE_OWNER_VEHICLE, "main"].join("-"),
  selector: selectVehicleOwnerVehicleData,
  redirect: Url.OC_VEHICLE_DAMAGES,
  content: [
    {
      title: "Dane pojazdu poszkodowanego",
      sections: [
        {
          id: "vehicle-owner-vehicle-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.SELECT,
              id: ComponentId.VEHICLE_TYPE,
              onChange: setVehicleType,
              label: "Typ pojazdu",
              required: true,
              items: [
                {
                  label:
                    "pojazd samochodowy (np. samochod osobowy, ciezarowy, motocykl, ciagnik, przyczepa)",
                  value: "car",
                },
                {
                  label:
                    "inne (np. maszyna rolnicza, budowlana, tramwaj, lodz, skuter wodny itp.)",
                  value: "other",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const formCar: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.VEHICLE_OWNER_VEHICLE,
  id: [FormId.VEHICLE_OWNER_VEHICLE, "car"].join("-"),
  selector: selectVehicleOwnerVehicleData,
  isVisible: selectIsSelectedVehicleCar,
  content: [
    {
      sections: [
        {
          id: "vehicle-owner-vehicle-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.REGISTRATION_NUMBER,
              label: "Numer rejestracyjny pojazdu poszkodowanego",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.VIN,
              label: "Numer VIN",
              tooltip: "Pole E w dowodzie rejestracyjnym",
            },
          ],
        },
        {
          id: "vehicle-owner-vehicle-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.DATE_PICKER,
              id: ComponentId.PRODUCTION_YEAR,
              isSubmitted: false,
              label: "Rok produkcji",
              yearOnly: true,
              required: true,
            },
            {
              type: FormElement.SELECT_MAKE,
              id: ComponentId.MAKE,
              label: "Marka",
              required: true,
              onChange: setAvailableModels,
              items: [...makes],
            },
          ],
        },
        {
          id: "vehicle-owner-vehicle-data-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.SELECT_MODEL,
              id: ComponentId.MODEL,
              label: "Model",
              required: true,
              items: [],
              selectAvailableModels: selectVehicleOwnerAvailableModels,
            },
            {
              type: FormElement.DATE_PICKER,
              id: ComponentId.REGISTRATION_DATE,
              isSubmitted: false,
              label: "Data pierwszej rejestracji",
              tooltip: "Pole B w dowodzie rejestracyjnym",
            },
          ],
        },
      ],
    },
  ],
};

export const formOther: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.VEHICLE_OWNER_VEHICLE,
  id: [FormId.VEHICLE_OWNER_VEHICLE, "other"].join("-"),
  selector: selectVehicleOwnerVehicleData,
  isVisible: selectIsSelectedVehicleOther,
  content: [
    {
      sections: [
        {
          id: "vehicle-owner-vehicle-data-5",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.DESCRIPTION,
              label: "Rodzaj pojazdu i numer identyfikacyjny",
              required: true,
              limit: 100,
            },
          ],
        },
      ],
    },
  ],
};
